/**
 * @desc 根据sku编号列表查询sku仓库包装信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.PlmSkuWarehousePackageRpcResponseDto>
>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuWarehousePackageBySkuNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
